import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/arrival-departure/page.tsx");
